import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import InspecaoQualidade from "model/qualidade/InspecaoQualidade";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class InspecaoQualidadeService implements BaseServiceCadastros<InspecaoQualidade> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/inspecaoQualidade/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<InspecaoQualidade>((resolve, reject): void => {
            api
                .get(`/inspecaoQualidade/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(inspecaoQualidade: InspecaoQualidade) {
        return new Promise<InspecaoQualidade>((resolve, reject): void => {
            api
                .post(`/inspecaoQualidade/incluir`, JSON.stringify(inspecaoQualidade))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(inspecaoQualidade: InspecaoQualidade) {
        return new Promise<InspecaoQualidade>((resolve, reject): void => {
            api
                .put(`/inspecaoQualidade/editar`, JSON.stringify(inspecaoQualidade))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/inspecaoQualidade/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTiposResultado() {
        return [
            { label: 'Numérico', value: 'NUMERICO' },
            { label: 'Texto', value: 'TEXTO' },
            { label: 'Sim/Não', value: 'SIM_NAO'},
            { label: "Aprovado/Reprovado", value: "APROVADO_REPROVADO"}
        ]
    }

    getTipoResultadoLabel(tipoResultado: string) {
        return this.getTiposResultado().find(tipo => tipo.value === tipoResultado)?.label;
    }

    getTipoResultadoInspecaoQualidadeFilter() {
        return [
            { label: 'Numérico', value: 'N' },
            { label: 'Texto', value: 'T' },
            { label: 'Sim/Não', value: 'S' },
            { label: 'Aprovado/Reprovado', value: 'A' },
        ]
    }

    proximoCodigo(){
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/inspecaoQualidade/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default InspecaoQualidadeService;